/**
 * Реактивный статус сети: navigator.onLine + события online/offline.
 * Синглтон — слушатели вешаются один раз при первом обращении.
 */
import { ref, type Ref } from 'vue'

const isOnline: Ref<boolean> = ref(
  typeof navigator === 'undefined' ? true : navigator.onLine
)

let started = false

function ensureStarted(): void {
  if (started || typeof window === 'undefined') {
    return
  }
  started = true
  window.addEventListener('online', () => {
    isOnline.value = true
  })
  window.addEventListener('offline', () => {
    isOnline.value = false
  })
}

export function useOnline(): { isOnline: Ref<boolean> } {
  ensureStarted()
  return { isOnline }
}
